module.exports = {"id":"226789","name":"Angelo Fulgini","rating":"71","photo":"./data/images/photos/2/226789.png","club":{"name":"Angers SCO","logo":"./data/images/clubs/AngersSCO.png"},"positions":["MC","MD","MDC","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AngeloFulgini0.json
// module id = 417
// module chunks = 0